export enum GroupType {
	SIMPLE = 'SIMPLE',
	HIERARCHY = 'HIERARCHY',
	WHOLE_HIERARCHY = 'WHOLE_HIERARCHY'
}
